/**
 * English - `schedule`: My schedule's booking settings and time off, the
 * person picker the owner and front desk get there, and the booking-settings
 * fields Our team shares. The page's older keys stay under `bookings.schedule.*`.
 * Conventions: see `common.ts`.
 */
const schedule: Record<string, string> = {
  'manager.intro': 'Working hours, booking settings and time off for anyone on your team. Changes show on the booking calendar straight away.',
  'picker.label': 'Whose schedule',
  'picker.info': 'Pick a person to change their hours, booking settings and time off. "Whole business" closes bookings with everybody, for a holiday or an event.',
  'picker.me': 'Me ({name})',
  'picker.business': 'Whole business',
  'people.loading': 'Loading your team…',
  'people.error': 'Your team could not be loaded. Please try again.',
  'people.none': 'Nobody is on Our team yet. Add people there to give them hours of their own; you can still close the whole business here.',
  'other.readonly': 'Only someone who can edit Our team can change their working hours and booking settings. You can still block their time off below.',
  'business.hint': 'Closing the whole business stops every booking, with anybody, for that time.',

  'hours.title': 'Working hours',
  'hours.save_other': 'Save their hours',
  'hours.saved_other': 'Hours saved for {name}.',

  'rules.title': 'Booking settings',
  'rules.info': 'How the booking calendar offers times for this person. Each one can follow the booking calendar or be set just for them.',
  'rules.follow': 'Same as the booking calendar',
  'rules.custom': 'A different number',
  'rules.slot_interval_minutes': 'A new appointment can start every',
  'rules.slot_interval_minutes.info': 'The gap between start times, 5 to 240 minutes. 15 offers 9:00, 9:15, 9:30… and 60 offers one start every hour.',
  'rules.slot_interval_minutes.follow': 'Same as the booking calendar (every {value} minutes)',
  'rules.slot_interval_minutes.unit': 'Minutes',
  'rules.booking_window_days': 'How far ahead customers can book',
  'rules.booking_window_days.info': 'How many days ahead a slot can be booked, 1 to 365. 30 keeps the calendar to the next month.',
  'rules.booking_window_days.follow': 'Same as the booking calendar ({value} days)',
  'rules.booking_window_days.unit': 'Days',
  'rules.lead_time_hours': 'Minimum notice',
  'rules.lead_time_hours.info': 'How many hours before it starts a slot stops being bookable online, 0 to 720. 0 allows booking right up to the start. The front desk is not held to it.',
  'rules.lead_time_hours.follow': 'Same as the booking calendar ({value} hours)',
  'rules.lead_time_hours.unit': 'Hours',
  'rules.error_number': 'Enter a whole number.',
  'rules.error_range': 'Enter a number from {min} to {max}.',
  'rules.save': 'Save booking settings',
  'rules.saving': 'Saving…',
  'rules.saved': 'Booking settings saved.',
  'rules.save_error': 'Booking settings could not be saved. Please try again.',

  'timeoff.title': 'Time off',
  'timeoff.intro': 'Block a time {name} cannot be booked - an afternoon, a day, or a week of leave. Appointments already booked are kept.',
  'timeoff.intro_business': 'Close the whole business for a holiday or an event. Nobody can be booked during it.',
  'timeoff.upcoming': 'Coming up',
  'timeoff.loading': 'Loading time off…',
  'timeoff.load_error': 'Time off could not be loaded. Please try again.',
  'timeoff.empty': 'No time off coming up.',
  'timeoff.business_badge': 'Whole business',
  'timeoff.when_day': '{date}, all day',
  'timeoff.when_days': '{from} - {to}, all day',
  'timeoff.when_hours': '{date}, {start} - {end}',
  'timeoff.when_span': '{from}, {start} - {to}, {end}',
  'timeoff.remove': 'Remove',
  'timeoff.remove_label': 'Remove time off: {when}',
  'timeoff.removed': 'Time off removed.',
  'timeoff.remove_error': 'Time off could not be removed. Please try again.',
  'timeoff.add_title': 'Add time off',
  'timeoff.all_day': 'All day',
  'timeoff.all_day_hint': 'Off from the start of the first day to the end of the last.',
  'timeoff.first_day': 'First day',
  'timeoff.last_day': 'Last day',
  'timeoff.last_day_hint': 'The same as the first day for a single day.',
  'timeoff.start_time': 'From',
  'timeoff.end_time': 'Until',
  'timeoff.reason': 'Reason (optional)',
  'timeoff.reason_hint': 'Only your team sees this, like "Conference" or "Diwali".',
  'timeoff.error_date': 'Pick a real date and time.',
  'timeoff.error_order': 'The end must be after the start.',
  'timeoff.add': 'Block this time',
  'timeoff.adding': 'Blocking…',
  'timeoff.added': 'Time off added.',
  'timeoff.add_error': 'Time off could not be added. Please try again.',
  'timeoff.clashes_title_one': '{count} appointment is already booked in this time',
  'timeoff.clashes_title_other': '{count} appointments are already booked in this time',
  'timeoff.clashes_body': 'They have not been cancelled. Contact these customers to move or cancel them from Bookings.',
  'timeoff.clashes_link': 'Open Bookings',
  'timeoff.clashes_dismiss': 'Dismiss',
};

export default schedule;
